import { AudioResponseDto } from '@/api-gen/api.schemas';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice, current } from '@reduxjs/toolkit';
import { ChatState } from 'app/models/chat/chatState.ts';


export enum ScenarioState {
  Chat = 'chat',
  Notes = 'notes',
  Completed = 'completed',
}

export type ScenarioPlayerState = {
  scenarioState: ScenarioState;
};

const initialState: ScenarioPlayerState = {
  scenarioState: ScenarioState.Chat,
};

export const scenarioPlayerSlice = createSlice({
  name: 'SCENARIO_PLAYER',
  initialState,
  reducers: {
    endScenario(state) {
      state.scenarioState = ScenarioState.Notes;
    },
    completeScenario(state) {
      state.scenarioState = ScenarioState.Completed;
    },
    skipNotes(state) {
      state.scenarioState = ScenarioState.Completed;
    },
    restartScenario(state) {
      state.scenarioState = ScenarioState.Chat;
    }
  },
});
